export const sideNavbar = {
  home: "Tuis",
  games: "Slots",
  allGames: "Almal",
  lottery: "Lotery",
  raffle: "Raffle",
  providers: "Verskaffers",
  categories: "Kategorie",
  casino: "Lewendige casino",
  casinos: "Lewendige casino",
  poker: "Poker",
  sports: "Sport",
  allSports: "Almal",
  soccer: "Sokker",
  baseball: "Bofbal",
  basketball: "Basketbal",
  e_sports: "E-Sport",
  nfl: "NFL",
  allPageSports: "Almal",
  parleyMenu: "Parley",
  allPageGames: "Almal",
  support: "Ondersteuning",
  live_casino: "Lewendige casino",
  bingo: "Bingo",
  horses: "Perde",
  hipism: "Perderesies",
  News: "Nuus",
  gameFeed: "Speletjiesstroom",
  miniJuegos: "Mini-speletjies",
  winnerTestimonials: "Getuienisse",
  sidebarSectionMain: "HOOF",
  sidebarSectionGames: "SPELETJIES",
  sidebarSectionMore: "MEER",
  sidebarSectionActions: "AKSIES",
};
